/** API `invalid_fields` key → human-readable title. */
export const EVENT_FIELD_TITLES: Record<string, string> = {
  name: 'Event Name',
  category: 'Category',
  // Both wire names map to the label the form actually shows.
  details: 'Description',
  description: 'Description',
  starts_at: 'Start Date',
  ends_at: 'End Date',
  timezone: 'Timezone',
  arrival_time_minutes: 'Arrival Time',
  recurrence_type: 'Repeat',
  days_of_week: 'Days Of Week',
  repeat_until: 'Repeat Until',
  address_name: 'Location Name',
  'address.street_1': 'Address Line 1',
  'address.street_2': 'Address Line 2',
  'address.city': 'City',
  'address.postal_code': 'Postal Code',
  'address.country_id': 'Country',
  'address.province_id': 'Province',
}
